// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9a1682c4","453":"126fcaae"}[chunkId] + ".chunk.js";
};